import { Link } from 'react-router-dom'

function FooterOne() {
    return (
        <footer className="footer-wrapper footer-layout1">
            <div className="widget-area">
                <div className="container">
                   
                    <div className="row justify-content-between">
                        <div className="col-md-6 col-xl-3">
                            <div className="widget footer-widget">
                                <div className="th-widget-about">
                                    <div className="about-logo">
                                          <Link to="/">
                                    
                                    <img
                                src="/assets/img/logo1.png"
                                alt="Mahakal Yatra"
                                width={270}
                                       />
                                        </Link>
                                    </div>
                                    <p className="about-text text-dark">
                                       <strong> Your complete travel partner in Ujjain:</strong>  For your stay, we offer 
                                       <strong>  premium and affordable comfortable hotels & homestays in Omkareshwar and Ujjain nearest to Mahakal Temple,</strong> along with delicious and hygienic restaurant food. Book our <strong> reliable cabs / taxi service</strong> for travel to Omkareshwar, heritage city Ujjain, or any other nearby places. For your Ujjain heritage and local tour, we provide affordable rental bikes / e-bikes for couples and E-rickshaws!
                                        </p>

                                    <div className="th-social">
                                        <Link to="https://www.facebook.com/share/1At2rGNdPf/">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                        <Link to="https://youtube.com/@mahakalyatra_official?si=ovcEeneu95XjIpfh">
                                            <i className="fab fa-youtube" />
                                        </Link>
                                       
                                       <Link to="https://wa.me/917000117811" target="_blank" rel="noopener noreferrer">
                                                    <i className="fab fa-whatsapp" />
                                                    </Link>

                                        <Link to="https://www.instagram.com/mahakalyatra.ujjain?igsh=MWUxMjRzZno5b3JhNw==">
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Quick Links</h3>
                                <div className="menu-all-pages-container">
                                    <ul className="menu text-dark">
    <li>
        <Link to="/" className="text-dark">Home</Link>
    </li>
    <li>
        <Link to="/about" className="text-dark">About us</Link>
    </li>
    <li>
        <Link to="/" className="text-dark">Our Service</Link>
    </li>

    <li>
        <Link to="/contact" className="text-dark">Tour Booking Now</Link>
    </li>
</ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Address</h3>
                                <div className="th-widget-contact"> 
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/phone.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p className='text-dark'>
                                                <Link to="tel:+917000117811" className="info-box_link">
                                                    +91 7000117811
                                                </Link>
                                            </p>
                                           
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/envelope.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p className='text-dark'>
                                                <Link
                                                    to="mailto:mahakalyatraujjain@gmail.com"
                                                    className="info-box_link"
                                                >
                                                    mahakalyatraujjain@gmail.com
                                                </Link>
                                            </p>
                                           
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets/img/icon/location-dot.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p className='text-dark'>Add. 01 meena building front of mahapaur bungalow Indira Gandhi Chauraha freeganj Ujjain 456010</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
           

        </footer>

    )
}

export default FooterOne
